import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withKeys as _withKeys, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "party-upload" }
const _hoisted_2 = {
  id: "doms",
  class: "h-[64px] px-[20px] flex items-center justify-between",
  style: {"border-bottom":"1px solid #e5e5e5"}
}
const _hoisted_3 = {
  key: 0,
  class: "input-card px-[24px] py-[12px] gap-[12px]"
}
const _hoisted_4 = { class: "mb-[12px] pt-[6px] text-[14px] text-[#374151] font-bold flex items-center justify-between" }
const _hoisted_5 = {
  key: 0,
  style: {"flex":"1"}
}
const _hoisted_6 = { class: "flex items-center w-full" }
const _hoisted_7 = {
  key: 1,
  style: {"flex":"1"}
}
const _hoisted_8 = { class: "flex flex-wrap gap-[8px] items-center" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 2,
  style: {"flex":"1"}
}
const _hoisted_12 = {
  key: 3,
  style: {"flex":"1"}
}
const _hoisted_13 = {
  key: 4,
  style: {"flex":"1"}
}
const _hoisted_14 = {
  key: 5,
  style: {"flex":"1"}
}
const _hoisted_15 = {
  key: 6,
  style: {"flex":"1"}
}
const _hoisted_16 = {
  key: 7,
  style: {"flex":"1"}
}
const _hoisted_17 = {
  key: 8,
  style: {"flex":"1"}
}
const _hoisted_18 = { class: "flex items-center gap-[10px] flex-wrap" }
const _hoisted_19 = ["onUpdate:modelValue"]
const _hoisted_20 = { class: "text-[12px] text-[#374151]" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = {
  key: 9,
  style: {"flex":"1"}
}
const _hoisted_24 = { class: "flex flex-col gap-[12px]" }
const _hoisted_25 = ["accept", "onChange"]
const _hoisted_26 = ["onDragover", "onDragleave", "onDrop", "onClick"]
const _hoisted_27 = {
  key: 0,
  class: "p-[12px]"
}
const _hoisted_28 = { class: "flex flex-wrap gap-[8px]" }
const _hoisted_29 = ["src"]
const _hoisted_30 = ["src"]
const _hoisted_31 = {
  key: 2,
  class: "text-[12px] text-[#6b7280]"
}
const _hoisted_32 = ["onClick"]
const _hoisted_33 = ["onClick"]
const _hoisted_34 = {
  key: 1,
  class: "flex flex-col items-center justify-center h-[100px] select-none"
}
const _hoisted_35 = { class: "w-[44px] h-[44px] rounded-full bg-[#f5f7fa] flex items-center justify-center mb-[10px]" }
const _hoisted_36 = { class: "text-[13px] text-[#303133]" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = {
  key: 10,
  style: {"flex":"1"},
  class: "flex items-center justify-between gap-[12px]"
}
const _hoisted_39 = {
  key: 11,
  class: "titleTyple",
  style: {"flex":"1"}
}
const _hoisted_40 = { class: "mb-[12px] pt-[6px] text-[14px] text-[#374151]" }
const _hoisted_41 = {
  key: 0,
  style: {"flex":"1"}
}
const _hoisted_42 = { class: "flex items-center w-full" }
const _hoisted_43 = {
  key: 1,
  style: {"flex":"1"}
}
const _hoisted_44 = { class: "flex flex-wrap gap-[8px] items-center" }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = ["onClick"]
const _hoisted_47 = {
  key: 2,
  style: {"flex":"1"}
}
const _hoisted_48 = {
  key: 3,
  style: {"flex":"1"}
}
const _hoisted_49 = {
  key: 4,
  style: {"flex":"1"}
}
const _hoisted_50 = {
  key: 5,
  style: {"flex":"1"}
}
const _hoisted_51 = { class: "flex items-center gap-[10px] flex-wrap" }
const _hoisted_52 = ["onUpdate:modelValue"]
const _hoisted_53 = { class: "text-[12px] text-[#374151]" }
const _hoisted_54 = ["onClick"]
const _hoisted_55 = ["onClick"]
const _hoisted_56 = {
  key: 6,
  style: {"flex":"1"}
}
const _hoisted_57 = { class: "flex flex-col gap-[12px]" }
const _hoisted_58 = ["accept", "onChange"]
const _hoisted_59 = ["onDragover", "onDragleave", "onDrop", "onClick"]
const _hoisted_60 = {
  key: 0,
  class: "p-[12px]"
}
const _hoisted_61 = { class: "grid grid-cols-6 gap-[8px]" }
const _hoisted_62 = ["src"]
const _hoisted_63 = {
  key: 1,
  class: "text-[12px] text-[#6b7280]"
}
const _hoisted_64 = ["onClick"]
const _hoisted_65 = ["onClick"]
const _hoisted_66 = {
  key: 1,
  class: "flex flex-col items-center justify-center h-[80px] select-none"
}
const _hoisted_67 = { class: "w-[44px] h-[44px] rounded-full bg-[#f5f7fa] flex items-center justify-center mb-[10px]" }
const _hoisted_68 = { class: "text-[13px] text-[#303133]" }
const _hoisted_69 = ["onClick"]
const _hoisted_70 = { class: "mt-[4px] text-[12px] text-[#909399]" }
const _hoisted_71 = { class: "tips text-[12px] text-[#aaa] mt-[10px]" }
const _hoisted_72 = { class: "tips text-[12px] text-[#aaa] mt-[10px]" }
const _hoisted_73 = { class: "btn flex justify-center mt-[20px]" }

import { onMounted, nextTick, ref, watch, onBeforeUnmount } from "vue";
import { useRouter, useRoute } from "vue-router";
import { ElMessageBox } from 'element-plus'
import { initGlobalConfig } from '@/common/initGlobalConfig'
import { initClient } from '@/common/inituser'
import { useMiscStore } from '@/stores/misc'
import { useUserStore } from '@/stores/user'
import Editer from '@/components/Editer/Editer.vue'
//@ts-ignore
import NewLoading from '@/components/loading/loadingComp.vue'
//@ts-ignore
import team from '@/components/topPanel/team/team.vue'
//@ts-ignore
import login from '@/components/topPanel/login/login.vue'
//@ts-ignore
import size from '@/components/fileActions/createDesign/size.vue'
import { getHoverInfo, uploadfiles, saveTemplate, analyzeText, getEditHoverInfo } from '@/api/plugin'
import { createCategory, createTag } from '@/api/ResourceMasonry'
import { ElMessage } from 'element-plus'

export default /*@__PURE__*/_defineComponent({
  __name: 'partyUploadEdit',
  setup(__props) {

const uploadsLoading = ref(false)
const dialogVisible = ref(false)
//@ts-ignore
const userStore = useUserStore()
const islogin = userStore.isLoggedIn
const rightpanelshow = ref(false)
const inputTree = ref([])
const inputsRef = ref<HTMLElement | null>(null)
const updateColumnsWidth = () => {
    const el = inputsRef.value
    if (!el) return
    const cs = getComputedStyle(el)
    const w = parseFloat(cs.columnWidth || '0') || 360
    const g = parseFloat(cs.columnGap || '0') || 20
    const children = Array.from(el.children) as HTMLElement[]
    const used = new Set(children.map(c => c.offsetLeft))
    const n = Math.min(3, used.size)
    if (n >= 3) {
        el.style.width = '100%'
        el.style.marginLeft = '0'
        el.style.marginRight = '0'
    } else {
        const target = n > 0 ? (n * w + (n - 1) * g) : w
        const max = el.parentElement ? el.parentElement.clientWidth : target
        el.style.width = `${Math.min(target, max)}px`
        el.style.marginLeft = 'auto'
        el.style.marginRight = 'auto'
    }
}
onMounted(async () => {
    await initGlobalConfig()
    await initClient()
    if (!islogin) {
        (window as any).openGlobalLogin?.()
        return
    };
    rightpanelshow.value = true
    getHoverInfos()
    nextTick(updateColumnsWidth)
    window.addEventListener('resize', updateColumnsWidth)
})
const getHoverInfos = async (params?: any) => {
    const corpCode = userStore.currentTeamInfo?.corp_code
    const res = await getEditHoverInfo({
        'edit_id': localStorage.getItem('edit_id') || '',
        'role_id': localStorage.getItem('role_id') || '',
        'corp_code': corpCode,
        ...params
    })
    console.log(res.data?.data)
    if (res.data?.data) {
        inputTree.value = res.data?.data;


    }
    nextTick(updateColumnsWidth)
}

watch(inputTree, () => nextTick(updateColumnsWidth), { deep: true })
onBeforeUnmount(() => {
    window.removeEventListener('resize', updateColumnsWidth)
})


const fileFromUrl = async (url: string, filename?: string) => {
    const res = await fetch(url)
    const blob = await res.blob()
    const name = filename || `file_${Date.now()}`
    return new File([blob], name, { type: blob.type || 'application/octet-stream' })
}
const uploadFile = async (filesList: any) => {
    let urllist: string[] = []
    for (let file of filesList) {
        if (!file.url) {
            urllist.push(file)
        } else {
            const fobj = await fileFromUrl(file.url, file.name)
            let formData = new FormData()
            formData.append('file', fobj, file.name)
            let res = await uploadfiles(formData)
            urllist.push(res.data?.data[0].url || '')
        }

        // if (res.data?.data?.url) {
        //     urllist.push(res.data?.data?.url)
        // }
    }
    return urllist
}
const uploadTemplate = async () => {
    uploadsLoading.value = true
    let list = (inputTree.value as any[]).filter((item: any) => item.inputType === 'title')
    let newList = [...inputTree.value, ...list.flatMap((l: any) => l.options || [])]
    let data = {}
    for (let item of newList) {
        if (!(item as any).custom && (item as any).inputType != 'upload' && (item as any).defaultValue) {
            try {
                data[(item as any).key] = (item as any).defaultValue.join(',')
            } catch (error) {
                data[(item as any).key] = (item as any).defaultValue
            }
        } else if ((item as any).inputType == 'upload') {
            let urllist = await uploadFile((item as any).defaultValue)
            data[(item as any).key] = urllist.join(',')
        }

    }
    let params = {
        edit_id: localStorage.getItem('edit_id'),
        dictionary: data
    }
    let res = await saveTemplate(params)
    uploadsLoading.value = false
    if (res.data?.code == 200) {
        ElMessage.success(res.data?.message || '上传成功')
        getHoverInfos()
    } else {
        ElMessage.error(res.data?.message || '上传失败')
    }
    // 
    // console.log(JSON.stringify(data))



}

const uploadInputRefs = ref<Record<string, HTMLInputElement | null>>({})
const setUploadInputRef = (key: string, el: HTMLInputElement | null) => {
    if (el) uploadInputRefs.value[key] = el
}
const openFileDialog = (item: any) => {
    const el = uploadInputRefs.value[item.key]
    if (el) el.click()
}
const dropActiveMap = ref<Record<string, boolean>>({})
const onDropZoneDragOver = (item: any) => {
    dropActiveMap.value[item.key] = true
}
const onDropZoneDragLeave = (item: any) => {
    dropActiveMap.value[item.key] = false
}
const onDropZoneDrop = (item: any, e: DragEvent) => {
    dropActiveMap.value[item.key] = false
    const files = Array.from(e.dataTransfer?.files || [])
    const arr = Array.isArray(item.defaultValue) ? [...item.defaultValue] : (item.defaultValue = [])
    const accepts = String(item.accept || '').split(',').map(s => s.trim().toLowerCase()).filter(Boolean)
    for (const file of files) {
        if (accepts.length && !acceptMatches(file, accepts)) continue
        const url = URL.createObjectURL(file)
        arr.push({ id: `${Date.now()}_${Math.random()}`, name: file.name, size: file.size, url, type: file.type, isImage: file.type.startsWith('image/') })
    }
    item.defaultValue = arr
}
const acceptMatches = (file: File, tokens: string[]) => {
    if (!tokens.length) return true
    const ext = '.' + String(file.name.split('.').pop() || '').toLowerCase()
    const type = String(file.type || '').toLowerCase()
    return tokens.some(t => {
        if (!t) return false
        if (t.startsWith('.')) return ext === t
        if (t.endsWith('/*')) return type.startsWith(t.slice(0, -1))
        return type === t
    })
}
const handleFilesSelected = (item: any, e: Event) => {
    const input = e.target as HTMLInputElement
    const files = Array.from(input.files || [])
    const arr = Array.isArray(item.defaultValue) ? [...item.defaultValue] : (item.defaultValue = [])
    const accepts = String(item.accept || '').split(',').map(s => s.trim().toLowerCase()).filter(Boolean)
    // console.log(accepts)
    for (const file of files) {
        // if (accepts.length && !acceptMatches(file, accepts)) continue
        const url = URL.createObjectURL(file)

        arr.push({ id: `${Date.now()}_${Math.random()}`, name: file.name, size: file.size, url, type: file.type, isImage: file.type.startsWith('image/') })
    }

    item.defaultValue = arr
    input.value = ''
}
const removeFile = (item: any, idx: number) => {
    const arr = Array.isArray(item.defaultValue) ? item.defaultValue : []
    const f = arr[idx]
    if (f && f.url) URL.revokeObjectURL(f.url)
    arr.splice(idx, 1)
    item.defaultValue = [...arr]
}
const formatSize = (size: number) => {
    if (size < 1024) return `${size} B`
    if (size < 1024 * 1024) return `${(size / 1024).toFixed(1)} KB`
    return `${(size / 1024 / 1024).toFixed(1)} MB`
}

const addColor = (item: any) => {
    const arr = Array.isArray(item.defaultValue) ? [...item.defaultValue] : []
    arr.push('#409EFF')
    item.defaultValue = arr
}
const removeColor = (item: any, idx: number) => {
    const arr = Array.isArray(item.defaultValue) ? item.defaultValue : []
    if (idx >= 0 && idx < arr.length) {
        arr.splice(idx, 1)
        item.defaultValue = [...arr]
    }
}







const customizingMap = ref<Record<string, boolean>>({})
const newOptionMap = ref<Record<string, string>>({})
const cascaderRootInputMap = ref<Record<string, string>>({})
const cascaderChildInputMap = ref<Record<string, string>>({})
const childMapKey = (itemKey: string, parentValue: string) => `${itemKey}::${String(parentValue)}`
const toggleOption = (item: any, value: any) => {
    const arr = Array.isArray(item.defaultValue) ? [...item.defaultValue] : []
    const idx = arr.indexOf(value)
    if (idx >= 0) {
        arr.splice(idx, 1)
    } else {
        arr.push(value)
    }
    item.defaultValue = arr
}
const MinusCustom = (ind: number) => {
    const custom = inputTree.value.find((item: any) => item.custom)
    if (!custom) return
    const list = Array.isArray((custom as any).list) ? (custom as any).list : ((custom as any).list = [])
    if (ind >= 0 && ind < list.length) {
        list.splice(ind, 1)
    }
}
const addCustom = () => {
    const custom = inputTree.value.find((item: any) => item.custom)
    if (!custom) return
    const list = Array.isArray((custom as any).list) ? (custom as any).list : ((custom as any).list = [])
    list.push({ 'key': '', 'value': '' })
}
const startCustomize = (item: any) => {
    customizingMap.value[item.key] = true
    newOptionMap.value[item.key] = ''
}
const commitCustomize = async (item: any) => {
    const key = item.key
    const v = (newOptionMap.value[key] || '').trim()
    customizingMap.value[key] = false
    if (!v) return
    const opts = Array.isArray(item.options) ? item.options : (item.options = [])
    if (opts.some((o: any) => String(o.value) === v)) {
        newOptionMap.value[key] = ''
        return
    }
    const id = await addTag(v, key)
    if (typeof id === 'number' && id > 0) {
        opts.push({ value: id, label: v })
    }
    toggleOption(item, id)
    newOptionMap.value[key] = ''
}
const buildCascaderOptionsWithAdd = (item: any) => {
    const opts = Array.isArray(item.options) ? item.options : []
    const roots = opts.map((o: any) => {
        const children = Array.isArray(o.children) ? o.children.map((c: any) => ({ ...c })) : []
        children.unshift({
            value: `__addchild__:${String(o.value)}`,
            label: '',
            disabled: true,
            isAddChild: true,
            parentValue: String(o.value)
        })
        return { ...o, children }
    })
    roots.unshift({ value: '__addroot__', label: '', disabled: true, isAddRoot: true })
    return roots
}
const commitAddRoot = async (item: any) => {
    const key = item.key
    const v = (cascaderRootInputMap.value[key] || '').trim()
    if (!v) return
    const opts = Array.isArray(item.options) ? item.options : (item.options = [])
    if (opts.some((o: any) => String(o.value) === v)) {
        cascaderRootInputMap.value[key] = ''
        return
    }
    const id = await addCategory(v, 0)
    if (typeof id === 'number' && id > 0) {
        opts.unshift({ value: id, label: v, children: [] })
        cascaderRootInputMap.value[key] = ''
    }


}
const handleRemove = (e: any, item: any) => {
    e.preventDefault()
    const idx = item.defaultValue.indexOf(e.file)
    if (idx >= 0) {
        item.defaultValue.splice(idx, 1)
    }
}
const commitAddChild = async (item: any, parentValue: string) => {
    const key = childMapKey(item.key, String(parentValue))
    const v = (cascaderChildInputMap.value[key] || '').trim()
    if (!v) return
    const opts = Array.isArray(item.options) ? item.options : (item.options = [])
    const parent = opts.find((o: any) => String(o.value) === String(parentValue))
    if (!parent) {
        cascaderChildInputMap.value[key] = ''
        return
    }
    const children = Array.isArray(parent.children) ? parent.children : (parent.children = [])
    if (children.some((c: any) => String(c.value) === v)) {
        cascaderChildInputMap.value[key] = ''
        return
    }
    const id = await addCategory(v, Number(parentValue))
    console.log(id)
    if (typeof id === 'number' && id > 0) {
        children.unshift({ value: id, label: v })
        cascaderChildInputMap.value[key] = ''
    }

}
const addCategory = async (name: string, parent_id: number) => {
    const res = await createCategory({ name: name, owner_type: ((userStore.currentTeamInfo?.corp_code) ? 'team' : 'user'), corp_code: ((userStore.currentTeamInfo?.corp_code) || ''), parent_id: parent_id })
    if (res.data.data.id) {
        return res.data.data.id
    } else {
        return 0
    }

}
const addTag = async (name: string, key: string) => {
    const res = await createTag({ name: name, owner_type: ((userStore.currentTeamInfo?.corp_code) ? 'team' : 'user'), corp_code: ((userStore.currentTeamInfo?.corp_code) || ''), key: key })
    if (res.data.data.id) {
        return res.data.data.id
    } else {
        return 0
    }
}



const createDesign = async (createParams: any) => {

    let template = inputTree.value.find((item: any) => item.inputType === 'template')
    console.log(template, 'asdasdasdasdasd')
    if (template && (template as any).options) {
        (template as any).options.push({ value: createParams.id, label: '新建模板' })
    }

    if (template && (template as any).defaultValue !== undefined) (template as any).defaultValue = createParams.id
    dialogVisible.value = false
    // console.log(createParams)
    // if (res.data.data.pk) {
    //     return res.data.data.pk
    // } else {
    //     return 0
    // }
}

const editTemplate = (template: any) => {
    dialogVisible.value = true
    const params = new URLSearchParams({
        id: String(template.value),
        mode: 'user',

    })
    window.open(`/editor?${params.toString()}`, '_blank')
}

const cancelsubmit = () => {
    getHoverInfos()
}

const analyzeTextBYAI = async () => {

    const found = inputTree.value.find((item: any) => item.key === 'title')
    const title = found ? (found as any).defaultValue : ''
    const img = inputTree.value.find((item: any) => item.key === 'scene_file')
    const imgUrl = img ? (img as any).defaultValue : ''
    if (!title && (!imgUrl || imgUrl.length === 0)) {
        ElMessage.error('请至少填写标题或上传图片')
        return
    }
    uploadsLoading.value = true
    let imglist: string[] = []
    if (Array.isArray(imgUrl) && imgUrl.length > 0) {
        imglist = await uploadFile(imgUrl)
    }

    const payload: any = {}
    if (title) payload.text = title
    if (imglist.length > 0) payload.imageBase64 = imglist.join(',')
    const res = await analyzeText(payload)

    if (res.data.code == 200) {
        const params: any = { aiResult: res.data.data }
        if (title) params.text = title
        if (imglist.length > 0) params.imageBase64 = imglist.join(',')
        uploadsLoading.value = false
        getHoverInfos(params)
    } else {
        uploadsLoading.value = false
    }
    // if (res.data.data) {
    //     inputTree.value.find((item: any) => item.key === 'title').defaultValue = res.data.data.title
    // }
}










return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_ElIcon = _resolveComponent("ElIcon")!
  const _component_el_input_tag = _resolveComponent("el-input-tag")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_Close = _resolveComponent("Close")!
  const _component_Upload = _resolveComponent("Upload")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          (rightpanelshow.value)
            ? (_openBlock(), _createBlock(team, { key: 0 }))
            : _createCommentVNode("", true)
        ]),
        _createVNode(login)
      ]),
      _createElementVNode("div", {
        class: "insputs",
        ref_key: "inputsRef",
        ref: inputsRef
      }, [
        _cache[12] || (_cache[12] = _createElementVNode("div", { class: "flex justify-end pr-[24px]" }, null, -1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(inputTree.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "break-inside-avoid"
          }, [
            (!item.custom)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("span", null, _toDisplayString(item.labelName) + "：", 1),
                    (item.key === 'title')
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          type: "primary",
                          size: "mini",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (analyzeTextBYAI()))
                        }, {
                          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                            _createTextVNode("AI一键解析", -1)
                          ]))]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  (item.inputType === 'cascader')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createVNode(_component_el_cascader, {
                          modelValue: item.defaultValue,
                          "onUpdate:modelValue": ($event: any) => ((item.defaultValue) = $event),
                          options: buildCascaderOptionsWithAdd(item),
                          style: {"width":"100%"},
                          placeholder: item.Placeholder,
                          filterable: true
                        }, {
                          default: _withCtx(({ data }) => [
                            _createElementVNode("div", _hoisted_6, [
                              _createElementVNode("span", null, _toDisplayString(data.label), 1),
                              (data.isAddRoot)
                                ? (_openBlock(), _createBlock(_component_el_input, {
                                    key: 0,
                                    modelValue: cascaderRootInputMap.value[item.key],
                                    "onUpdate:modelValue": ($event: any) => ((cascaderRootInputMap.value[item.key]) = $event),
                                    size: "small",
                                    placeholder: "输入后回车",
                                    class: "w-[140px]",
                                    onKeyup: _withKeys(($event: any) => (commitAddRoot(item)), ["enter"]),
                                    onBlur: ($event: any) => (commitAddRoot(item))
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeyup", "onBlur"]))
                                : (data.isAddChild)
                                  ? (_openBlock(), _createBlock(_component_el_input, {
                                      key: 1,
                                      modelValue: cascaderChildInputMap.value[childMapKey(item.key, data.parentValue)],
                                      "onUpdate:modelValue": ($event: any) => ((cascaderChildInputMap.value[childMapKey(item.key, data.parentValue)]) = $event),
                                      size: "small",
                                      placeholder: "输入后回车",
                                      class: "w-[140px]",
                                      onKeyup: _withKeys(($event: any) => (commitAddChild(item, data.parentValue)), ["enter"]),
                                      onBlur: ($event: any) => (commitAddChild(item, data.parentValue))
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeyup", "onBlur"]))
                                  : _createCommentVNode("", true)
                            ])
                          ]),
                          _: 2
                        }, 1032, ["modelValue", "onUpdate:modelValue", "options", "placeholder"])
                      ]))
                    : (item.inputType === 'checkbox')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.options, (opt) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: opt.value,
                                class: _normalizeClass(["px-[10px] py-[6px] rounded-[6px] text-[12px] cursor-pointer select-none border", item.defaultValue.includes(opt.value) ? 'bg-[#eef2ff] border-[#6366f1] text-[#3f51b5]' : 'bg-[#f9fafb] border-[#e5e7eb] text-[#374151]']),
                                onClick: ($event: any) => (toggleOption(item, opt.value))
                              }, _toDisplayString(opt.label), 11, _hoisted_9))
                            }), 128)),
                            (item.customize)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  (customizingMap.value[item.key])
                                    ? (_openBlock(), _createBlock(_component_el_input, {
                                        key: 0,
                                        modelValue: newOptionMap.value[item.key],
                                        "onUpdate:modelValue": ($event: any) => ((newOptionMap.value[item.key]) = $event),
                                        size: "small",
                                        placeholder: "输入后回车添加",
                                        class: "w-[140px]",
                                        onKeyup: _withKeys(($event: any) => (commitCustomize(item)), ["enter"]),
                                        onBlur: ($event: any) => (commitCustomize(item))
                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeyup", "onBlur"]))
                                    : (_openBlock(), _createElementBlock("div", {
                                        key: 1,
                                        class: "px-[8px] py-[5px] rounded-[6px] text-[12px] cursor-pointer select-none border border-dashed bg-[#fafafa] text-[#6b7280] flex items-center gap-[4px]",
                                        onClick: ($event: any) => (startCustomize(item))
                                      }, [
                                        _createVNode(_component_ElIcon, { size: "14px" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_Plus)
                                          ]),
                                          _: 1
                                        })
                                      ], 8, _hoisted_10))
                                ], 64))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : (item.inputType === 'multipleSelectCreate')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            _createVNode(_component_el_input_tag, {
                              modelValue: item.defaultValue,
                              "onUpdate:modelValue": ($event: any) => ((item.defaultValue) = $event),
                              placeholder: "输入完毕后请点击回车键",
                              filterable: "",
                              clearable: ""
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ]))
                        : (item.inputType === 'select')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                              _createVNode(_component_el_select, {
                                modelValue: item.defaultValue,
                                "onUpdate:modelValue": ($event: any) => ((item.defaultValue) = $event),
                                placeholder: item.Placeholder,
                                filterable: ""
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.options, (opt) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: opt.value,
                                      label: opt.label,
                                      value: opt.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1032, ["modelValue", "onUpdate:modelValue", "placeholder"])
                            ]))
                          : (item.inputType === 'input')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                _createVNode(_component_el_input, {
                                  modelValue: item.defaultValue,
                                  "onUpdate:modelValue": ($event: any) => ((item.defaultValue) = $event),
                                  placeholder: item.Placeholder
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])
                              ]))
                            : (item.inputType === 'textarea')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                  _createVNode(_component_el_input, {
                                    modelValue: item.defaultValue,
                                    "onUpdate:modelValue": ($event: any) => ((item.defaultValue) = $event),
                                    placeholder: item.Placeholder,
                                    type: "textarea"
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])
                                ]))
                              : (item.inputType === 'richText')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                    _createVNode(Editer, {
                                      modelValue: item.defaultValue,
                                      "onUpdate:modelValue": ($event: any) => ((item.defaultValue) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]))
                                : (item.inputType === 'radio')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                      _createVNode(_component_el_radio_group, {
                                        modelValue: item.defaultValue,
                                        "onUpdate:modelValue": ($event: any) => ((item.defaultValue) = $event),
                                        placeholder: item.Placeholder
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.options, (opt) => {
                                            return (_openBlock(), _createBlock(_component_el_radio, {
                                              key: opt.value,
                                              label: opt.value,
                                              value: opt.value
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(opt.label), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["label", "value"]))
                                          }), 128))
                                        ]),
                                        _: 2
                                      }, 1032, ["modelValue", "onUpdate:modelValue", "placeholder"])
                                    ]))
                                  : (item.inputType === 'color')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                        _createElementVNode("div", _hoisted_18, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((Array.isArray(item.defaultValue) ? item.defaultValue : []), (c, i) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: i,
                                              class: "flex items-center gap-[10px] px-[12px] py-[8px] rounded-[10px] bg-[#f8fafc] border border-[#e5e7eb]"
                                            }, [
                                              _createElementVNode("div", {
                                                class: "w-[20px] h-[20px] rounded-full p-0 cursor-pointer",
                                                style: _normalizeStyle({ backgroundColor: c })
                                              }, [
                                                _withDirectives(_createElementVNode("input", {
                                                  type: "color",
                                                  "onUpdate:modelValue": ($event: any) => ((item.defaultValue[i]) = $event),
                                                  class: "w-[20px] h-[20px] rounded-full p-0 cursor-pointer opacity-0"
                                                }, null, 8, _hoisted_19), [
                                                  [_vModelText, item.defaultValue[i]]
                                                ])
                                              ], 4),
                                              _createElementVNode("span", _hoisted_20, _toDisplayString(c), 1),
                                              _createElementVNode("span", {
                                                class: "text-[#9ca3af] cursor-pointer text-[12px]",
                                                onClick: _withModifiers(($event: any) => (removeColor(item, i)), ["stop"])
                                              }, "×", 8, _hoisted_21)
                                            ]))
                                          }), 128)),
                                          _createElementVNode("div", {
                                            class: "px-[8px] py-[6px] rounded-[10px] text-[12px] cursor-pointer select-none border border-dashed bg-[#fafafa] text-[#6b7280] flex items-center gap-[4px]",
                                            onClick: ($event: any) => (addColor(item))
                                          }, [
                                            _createVNode(_component_ElIcon, { size: "14px" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_Plus)
                                              ]),
                                              _: 1
                                            }),
                                            _cache[3] || (_cache[3] = _createElementVNode("span", null, "添加颜色", -1))
                                          ], 8, _hoisted_22)
                                        ])
                                      ]))
                                    : (item.inputType === 'upload')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                          _createElementVNode("div", _hoisted_24, [
                                            _createElementVNode("input", {
                                              ref_for: true,
                                              ref: el => setUploadInputRef(item.key, el),
                                              type: "file",
                                              style: {"display":"none"},
                                              accept: item.accept || 'image/*',
                                              multiple: "",
                                              onChange: ($event: any) => (handleFilesSelected(item, $event))
                                            }, null, 40, _hoisted_25),
                                            _createElementVNode("div", {
                                              class: _normalizeClass(["upload-zone rounded-[12px] border bg-white w-full", dropActiveMap.value[item.key] ? 'border-[#a0cfff] bg-[#ecf5ff]' : 'border-[#e5e7eb] bg-white']),
                                              onDragover: _withModifiers(($event: any) => (onDropZoneDragOver(item)), ["prevent"]),
                                              onDragleave: _withModifiers(($event: any) => (onDropZoneDragLeave(item)), ["prevent"]),
                                              onDrop: _withModifiers(($event: any) => (onDropZoneDrop(item, $event)), ["prevent"]),
                                              onClick: ($event: any) => (openFileDialog(item))
                                            }, [
                                              (Array.isArray(item.defaultValue) && item.defaultValue.length)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                                    _createElementVNode("div", _hoisted_28, [
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.defaultValue, (f, i) => {
                                                        return (_openBlock(), _createElementBlock("div", {
                                                          key: i,
                                                          class: "relative group w-[80px] h-[80px] overflow-hidden rounded-[8px] bg-[#f3f4f6] flex items-center justify-center"
                                                        }, [
                                                          (f.isImage)
                                                            ? (_openBlock(), _createElementBlock("img", {
                                                                key: 0,
                                                                src: f.url,
                                                                class: "w-full h-full object-cover"
                                                              }, null, 8, _hoisted_29))
                                                            : (!f.url)
                                                              ? (_openBlock(), _createElementBlock("img", {
                                                                  key: 1,
                                                                  src: f,
                                                                  class: "w-full h-full object-cover"
                                                                }, null, 8, _hoisted_30))
                                                              : (_openBlock(), _createElementBlock("span", _hoisted_31, "文件")),
                                                          _createElementVNode("div", {
                                                            class: "absolute top-[6px] right-[6px] w-[22px] h-[22px] bg-white rounded-full shadow border border-[#e5e7eb] cursor-pointer flex items-center justify-center",
                                                            onClick: _withModifiers(($event: any) => (removeFile(item, i)), ["stop"])
                                                          }, [
                                                            _createVNode(_component_ElIcon, {
                                                              size: "14px",
                                                              class: "text-[#303133]"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_Close)
                                                              ]),
                                                              _: 1
                                                            })
                                                          ], 8, _hoisted_32)
                                                        ]))
                                                      }), 128)),
                                                      _createElementVNode("div", {
                                                        class: "w-[80px] h-[80px] rounded-[8px] border border-dashed flex items-center justify-center cursor-pointer text-[#6b7280]",
                                                        onClick: _withModifiers(($event: any) => (openFileDialog(item)), ["stop"])
                                                      }, [
                                                        _createVNode(_component_ElIcon, { size: "24px" }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_Plus)
                                                          ]),
                                                          _: 1
                                                        })
                                                      ], 8, _hoisted_33)
                                                    ])
                                                  ]))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                                    _createElementVNode("div", _hoisted_35, [
                                                      _createVNode(_component_ElIcon, {
                                                        size: "20px",
                                                        class: "text-[#909399]"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_Upload)
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _createElementVNode("div", _hoisted_36, [
                                                      _createElementVNode("span", {
                                                        class: "text-[#409EFF] cursor-pointer",
                                                        onClick: _withModifiers(($event: any) => (openFileDialog(item)), ["stop"])
                                                      }, "点击上传", 8, _hoisted_37)
                                                    ]),
                                                    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "mt-[4px] text-[12px] text-[#909399]" }, "支持 ZIP、RAR 格式", -1))
                                                  ]))
                                            ], 42, _hoisted_26)
                                          ])
                                        ]))
                                      : _createCommentVNode("", true),
                  (item.inputType === 'template')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                        _createVNode(_component_el_select, {
                          modelValue: item.defaultValue,
                          "onUpdate:modelValue": ($event: any) => ((item.defaultValue) = $event),
                          placeholder: item.Placeholder,
                          filterable: "",
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.options, (template) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: template.id,
                                filterable: "",
                                class: "flex items-center justify-between",
                                value: template.value,
                                label: template.label
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", null, _toDisplayString(template.label), 1),
                                  _cache[6] || (_cache[6] = _createTextVNode()),
                                  _createVNode(_component_el_button, {
                                    type: "text",
                                    size: "mini",
                                    onClick: _withModifiers(($event: any) => (editTemplate(template)), ["stop"])
                                  }, {
                                    default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                      _createTextVNode("编辑", -1)
                                    ]))]),
                                    _: 1
                                  }, 8, ["onClick"])
                                ]),
                                _: 2
                              }, 1032, ["value", "label"]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1032, ["modelValue", "onUpdate:modelValue", "placeholder"]),
                        _createVNode(_component_el_button, {
                          type: "primary",
                          size: "mini",
                          onClick: ($event: any) => (editTemplate({ value: item.defaultValue }))
                        }, {
                          default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                            _createTextVNode("编辑模板", -1)
                          ]))]),
                          _: 1
                        }, 8, ["onClick"])
                      ]))
                    : (item.inputType === 'title')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((Array.isArray(item.options) ? item.options : []), (sub) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: sub.key || sub.value,
                              class: "input-card px-[24px] py-[12px] gap-[12px]"
                            }, [
                              _createElementVNode("div", _hoisted_40, _toDisplayString(sub.labelName) + "：", 1),
                              (sub.inputType === 'cascader')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                    _createVNode(_component_el_cascader, {
                                      modelValue: sub.defaultValue,
                                      "onUpdate:modelValue": ($event: any) => ((sub.defaultValue) = $event),
                                      options: buildCascaderOptionsWithAdd(sub),
                                      style: {"width":"100%"},
                                      placeholder: sub.Placeholder,
                                      filterable: true
                                    }, {
                                      default: _withCtx(({ data }) => [
                                        _createElementVNode("div", _hoisted_42, [
                                          _createElementVNode("span", null, _toDisplayString(data.label), 1),
                                          (data.isAddRoot)
                                            ? (_openBlock(), _createBlock(_component_el_input, {
                                                key: 0,
                                                modelValue: cascaderRootInputMap.value[sub.key],
                                                "onUpdate:modelValue": ($event: any) => ((cascaderRootInputMap.value[sub.key]) = $event),
                                                size: "small",
                                                placeholder: "输入后回车",
                                                class: "w-[140px]",
                                                onKeyup: _withKeys(($event: any) => (commitAddRoot(sub)), ["enter"]),
                                                onBlur: ($event: any) => (commitAddRoot(sub))
                                              }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeyup", "onBlur"]))
                                            : (data.isAddChild)
                                              ? (_openBlock(), _createBlock(_component_el_input, {
                                                  key: 1,
                                                  modelValue: cascaderChildInputMap.value[childMapKey(sub.key, data.parentValue)],
                                                  "onUpdate:modelValue": ($event: any) => ((cascaderChildInputMap.value[childMapKey(sub.key, data.parentValue)]) = $event),
                                                  size: "small",
                                                  placeholder: "输入后回车",
                                                  class: "w-[140px]",
                                                  onKeyup: _withKeys(($event: any) => (commitAddChild(sub, data.parentValue)), ["enter"]),
                                                  onBlur: ($event: any) => (commitAddChild(sub, data.parentValue))
                                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeyup", "onBlur"]))
                                              : _createCommentVNode("", true)
                                        ])
                                      ]),
                                      _: 2
                                    }, 1032, ["modelValue", "onUpdate:modelValue", "options", "placeholder"])
                                  ]))
                                : (sub.inputType === 'checkbox')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                      _createElementVNode("div", _hoisted_44, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sub.options, (opt) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            key: opt.value,
                                            class: _normalizeClass(["px-[10px] py-[6px] rounded-[6px] text-[12px] cursor-pointer select-none border", sub.defaultValue.includes(opt.value) ? 'bg-[#eef2ff] border-[#6366f1] text-[#3f51b5]' : 'bg-[#f9fafb] border-[#e5e7eb] text-[#374151]']),
                                            onClick: ($event: any) => (toggleOption(sub, opt.value))
                                          }, _toDisplayString(opt.label), 11, _hoisted_45))
                                        }), 128)),
                                        (sub.customize)
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                              (customizingMap.value[sub.key])
                                                ? (_openBlock(), _createBlock(_component_el_input, {
                                                    key: 0,
                                                    modelValue: newOptionMap.value[sub.key],
                                                    "onUpdate:modelValue": ($event: any) => ((newOptionMap.value[sub.key]) = $event),
                                                    size: "small",
                                                    placeholder: "输入后回车添加",
                                                    class: "w-[140px]",
                                                    onKeyup: _withKeys(($event: any) => (commitCustomize(sub)), ["enter"]),
                                                    onBlur: ($event: any) => (commitCustomize(sub))
                                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeyup", "onBlur"]))
                                                : (_openBlock(), _createElementBlock("div", {
                                                    key: 1,
                                                    class: "px-[8px] py-[5px] rounded-[6px] text-[12px] cursor-pointer select-none border border-dashed bg-[#fafafa] text-[#6b7280] flex items-center gap-[4px]",
                                                    onClick: ($event: any) => (startCustomize(sub))
                                                  }, [
                                                    _createVNode(_component_ElIcon, { size: "14px" }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_Plus)
                                                      ]),
                                                      _: 1
                                                    })
                                                  ], 8, _hoisted_46))
                                            ], 64))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]))
                                  : (sub.inputType === 'multipleSelectCreate')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                        _createVNode(_component_el_input_tag, {
                                          modelValue: sub.defaultValue,
                                          "onUpdate:modelValue": ($event: any) => ((sub.defaultValue) = $event),
                                          placeholder: "输入完毕后请点击回车键",
                                          filterable: "",
                                          clearable: ""
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                      ]))
                                    : (sub.inputType === 'select')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                          _createVNode(_component_el_select, {
                                            modelValue: sub.defaultValue,
                                            "onUpdate:modelValue": ($event: any) => ((sub.defaultValue) = $event),
                                            placeholder: sub.Placeholder,
                                            filterable: ""
                                          }, {
                                            default: _withCtx(() => [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sub.options, (opt) => {
                                                return (_openBlock(), _createBlock(_component_el_option, {
                                                  key: opt.value,
                                                  label: opt.label,
                                                  value: opt.value
                                                }, null, 8, ["label", "value"]))
                                              }), 128))
                                            ]),
                                            _: 2
                                          }, 1032, ["modelValue", "onUpdate:modelValue", "placeholder"])
                                        ]))
                                      : (sub.inputType === 'input')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                            _createVNode(_component_el_input, {
                                              modelValue: sub.defaultValue,
                                              "onUpdate:modelValue": ($event: any) => ((sub.defaultValue) = $event),
                                              placeholder: sub.Placeholder
                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])
                                          ]))
                                        : (sub.inputType === 'color')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                              _createElementVNode("div", _hoisted_51, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((Array.isArray(sub.defaultValue) ? sub.defaultValue : []), (c, i) => {
                                                  return (_openBlock(), _createElementBlock("div", {
                                                    key: i,
                                                    class: "flex items-center gap-[10px] px-[12px] py-[8px] rounded-[10px] bg-[#f8fafc] border border-[#e5e7eb]"
                                                  }, [
                                                    _withDirectives(_createElementVNode("input", {
                                                      type: "color",
                                                      "onUpdate:modelValue": ($event: any) => ((sub.defaultValue[i]) = $event),
                                                      class: "w-[20px] h-[20px] rounded-full border border-[#e5e7eb] p-0 cursor-pointer"
                                                    }, null, 8, _hoisted_52), [
                                                      [_vModelText, sub.defaultValue[i]]
                                                    ]),
                                                    _createElementVNode("span", _hoisted_53, _toDisplayString(c), 1),
                                                    _createElementVNode("span", {
                                                      class: "text-[#9ca3af] cursor-pointer text-[12px]",
                                                      onClick: _withModifiers(($event: any) => (removeColor(sub, i)), ["stop"])
                                                    }, "×", 8, _hoisted_54)
                                                  ]))
                                                }), 128)),
                                                _createElementVNode("div", {
                                                  class: "px-[8px] py-[6px] rounded-[10px] text-[12px] cursor-pointer select-none border border-dashed bg-[#fafafa] text-[#6b7280] flex items-center gap-[4px]",
                                                  onClick: ($event: any) => (addColor(sub))
                                                }, [
                                                  _createVNode(_component_ElIcon, { size: "14px" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_Plus)
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _cache[8] || (_cache[8] = _createElementVNode("span", null, "添加颜色", -1))
                                                ], 8, _hoisted_55)
                                              ])
                                            ]))
                                          : (sub.inputType === 'upload')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                                _createElementVNode("div", _hoisted_57, [
                                                  _createElementVNode("input", {
                                                    ref_for: true,
                                                    ref: el => setUploadInputRef(sub.key, el),
                                                    type: "file",
                                                    style: {"display":"none"},
                                                    accept: sub.accept || 'image/*',
                                                    multiple: "",
                                                    onChange: ($event: any) => (handleFilesSelected(sub, $event))
                                                  }, null, 40, _hoisted_58),
                                                  _createElementVNode("div", {
                                                    class: _normalizeClass(["upload-zone rounded-[12px] border bg-white w-full", dropActiveMap.value[sub.key] ? 'border-[#a0cfff] bg-[#ecf5ff]' : 'border-[#e5e7eb] bg-white']),
                                                    onDragover: _withModifiers(($event: any) => (onDropZoneDragOver(sub)), ["prevent"]),
                                                    onDragleave: _withModifiers(($event: any) => (onDropZoneDragLeave(sub)), ["prevent"]),
                                                    onDrop: _withModifiers(($event: any) => (onDropZoneDrop(sub, $event)), ["prevent"]),
                                                    onClick: ($event: any) => (openFileDialog(sub))
                                                  }, [
                                                    (Array.isArray(sub.defaultValue) && sub.defaultValue.length)
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                                                          _createElementVNode("div", _hoisted_61, [
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sub.defaultValue, (f, i) => {
                                                              return (_openBlock(), _createElementBlock("div", {
                                                                key: f.id,
                                                                class: "relative group w-[80px] h-[80px] overflow-hidden rounded-[8px] bg-[#f3f4f6] flex items-center justify-center"
                                                              }, [
                                                                (f.isImage)
                                                                  ? (_openBlock(), _createElementBlock("img", {
                                                                      key: 0,
                                                                      src: f.url,
                                                                      class: "w-full h-full object-cover"
                                                                    }, null, 8, _hoisted_62))
                                                                  : (_openBlock(), _createElementBlock("span", _hoisted_63, "文件")),
                                                                _createElementVNode("div", {
                                                                  class: "absolute top-[6px] right-[6px] w-[22px] h-[22px] bg-white rounded-full shadow border border-[#e5e7eb] cursor-pointer flex items-center justify-center",
                                                                  onClick: _withModifiers(($event: any) => (removeFile(sub, i)), ["stop"])
                                                                }, [
                                                                  _createVNode(_component_ElIcon, {
                                                                    size: "14px",
                                                                    class: "text-[#303133]"
                                                                  }, {
                                                                    default: _withCtx(() => [
                                                                      _createVNode(_component_Close)
                                                                    ]),
                                                                    _: 1
                                                                  })
                                                                ], 8, _hoisted_64)
                                                              ]))
                                                            }), 128)),
                                                            _createElementVNode("div", {
                                                              class: "w-[80px] h-[80px] rounded-[8px] border border-dashed flex items-center justify-center cursor-pointer text-[#6b7280]",
                                                              onClick: _withModifiers(($event: any) => (openFileDialog(sub)), ["stop"])
                                                            }, [
                                                              _createVNode(_component_ElIcon, { size: "24px" }, {
                                                                default: _withCtx(() => [
                                                                  _createVNode(_component_Plus)
                                                                ]),
                                                                _: 1
                                                              })
                                                            ], 8, _hoisted_65)
                                                          ])
                                                        ]))
                                                      : (_openBlock(), _createElementBlock("div", _hoisted_66, [
                                                          _createElementVNode("div", _hoisted_67, [
                                                            _createVNode(_component_ElIcon, {
                                                              size: "20px",
                                                              class: "text-[#909399]"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_Upload)
                                                              ]),
                                                              _: 1
                                                            })
                                                          ]),
                                                          _createElementVNode("div", _hoisted_68, [
                                                            _cache[9] || (_cache[9] = _createTextVNode(" 拖放文件到此处或 ", -1)),
                                                            _createElementVNode("span", {
                                                              class: "text-[#409EFF] cursor-pointer",
                                                              onClick: _withModifiers(($event: any) => (openFileDialog(sub)), ["stop"])
                                                            }, "点击上传", 8, _hoisted_69)
                                                          ]),
                                                          _createElementVNode("div", _hoisted_70, "支持" + _toDisplayString(item.accept) + "格式 ", 1)
                                                        ]))
                                                  ], 42, _hoisted_59)
                                                ])
                                              ]))
                                            : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_71, _toDisplayString(item.tips), 1)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_72, _toDisplayString(item.tips), 1)
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128)),
        _createElementVNode("div", _hoisted_73, [
          _createVNode(_component_el_button, {
            style: {"width":"200px"},
            type: "primary",
            onClick: cancelsubmit
          }, {
            default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
              _createTextVNode("取消", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            style: {"width":"200px"},
            type: "primary",
            onClick: uploadTemplate
          }, {
            default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
              _createTextVNode("提交审核", -1)
            ]))]),
            _: 1
          })
        ])
      ], 512)
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dialogVisible).value = $event)),
      title: "",
      width: "430",
      top: "100px",
      "append-to-body": ""
    }, {
      default: _withCtx(() => [
        _createVNode(size, { onCreate: createDesign })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (uploadsLoading.value)
      ? (_openBlock(), _createBlock(NewLoading, {
          key: 0,
          fullscreen: ""
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})